import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { IMAGES, CONTACT } from '../constants/images';
import { Button } from './ui/button';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { 
      name: 'Services', 
      path: '/services',
      submenu: [
        { name: 'Leg & Foot Care', path: '/services/leg-foot-care' },
        { name: 'Liver & GI', path: '/services/liver-gi' },
        { name: 'Kidney & Dialysis', path: '/services/kidney-dialysis' },
        { name: 'Women\'s Health', path: '/services/womens-health' },
        { name: 'Emergency', path: '/services/emergency' },
        { name: 'Miscellaneous', path: '/services/miscellaneous' }
      ]
    },
    { name: 'Qualifications', path: '/qualifications' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md border-b-2" style={{ borderImage: 'linear-gradient(90deg, #f1d9a8, #d4b483, #f1d9a8) 1' }}>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center">
            <img src={IMAGES.logo} alt="Angionova Clinic - Dr Punit Mahajan" className="h-16 w-auto" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigation.map((item) => (
              <div key={item.name} className="relative group">
                <Link
                  to={item.path}
                  className={`text-sm font-medium transition-colors hover:text-amber-600 ${
                    location.pathname === item.path ? 'text-amber-600' : 'text-slate-700'
                  }`}
                >
                  {item.name}
                </Link>
                {item.submenu && (
                  <div className="absolute left-0 mt-2 w-56 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 bg-white shadow-lg rounded-lg py-2">
                    {item.submenu.map((subitem) => (
                      <Link
                        key={subitem.name}
                        to={subitem.path}
                        className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-amber-600 transition-colors"
                      >
                        {subitem.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <a href={`tel:${CONTACT.phone}`}>
              <Button className="bg-blue-900 hover:bg-blue-800 text-white">
                <Phone className="w-4 h-4 mr-2" />
                Book Appointment
              </Button>
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-md text-slate-700 hover:bg-slate-100"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="lg:hidden border-t border-slate-200">
          <div className="px-4 py-4 space-y-3">
            {navigation.map((item) => (
              <div key={item.name}>
                <Link
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block py-2 text-base font-medium ${
                    location.pathname === item.path ? 'text-amber-600' : 'text-slate-700'
                  }`}
                >
                  {item.name}
                </Link>
                {item.submenu && (
                  <div className="pl-4 space-y-2 mt-2">
                    {item.submenu.map((subitem) => (
                      <Link
                        key={subitem.name}
                        to={subitem.path}
                        onClick={() => setIsMenuOpen(false)}
                        className="block py-1 text-sm text-slate-600 hover:text-amber-600"
                      >
                        {subitem.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <a href={`tel:${CONTACT.phone}`} className="block pt-4">
              <Button className="w-full bg-blue-900 hover:bg-blue-800 text-white">
                <Phone className="w-4 h-4 mr-2" />
                Book Appointment
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
